import API from '../../../lib/commons/api'
import {
  ProjectCreateProps,
  ProjectDeleteProps,
  ProjectDetail,
  ProjectUpdateDeltaProps,
} from '../../../lib/functions/project'
import { ProjectForSelection } from '../../../view/pages/ProgramManagement/programManagement'

// プロジェクトAPIを新アーキ(infrastructure)から提供する。
// リクエスト・レスポンス型は二重管理を避けるため lib から再エクスポートする
// （ステータス等の値・型は domain/entity/ProjectEntity を参照すること）。
export type {
  ProjectCreateProps,
  ProjectUpdateDeltaProps,
  ProjectDeleteProps,
  ProjectDetail,
} from '../../../lib/functions/project'

// 作成API（POST /api/v1/projects）のレスポンス。コードは返らない点に注意。
export type CreatedProject = {
  uuid: string
  lockVersion: number
}

export const fetchAllProjects = async (): Promise<ProjectForSelection[]> => {
  const response = await API.functional.request('GET', '/api/v1/projects/all')
  return response.json as ProjectForSelection[]
}

export const createProject = async (
  input: ProjectCreateProps
): Promise<CreatedProject> => {
  const response = await API.functional.request(
    'POST',
    '/api/v1/projects',
    input
  )
  return response.json as CreatedProject
}

export const updateProjectDelta = async (
  input: ProjectUpdateDeltaProps
): Promise<void> => {
  await API.functional.request('PUT', '/api/v1/projects/delta', input)
}

// プロジェクト情報画面（プロジェクトメニュー）用の更新。権限・対象プロジェクトの
// チェックが project.update とは異なる別エンドポイント。入力型は共通。
export const updateProjectInformationDelta = async (
  input: ProjectUpdateDeltaProps
): Promise<void> => {
  await API.functional.request(
    'PUT',
    '/api/v1/projects/information/delta',
    input
  )
}

export const deleteProject = async (
  input: ProjectDeleteProps
): Promise<void> => {
  await API.functional.request('DELETE', '/api/v1/projects', input)
}

export const fetchProjectDetailByUuid = async (
  uuid: string
): Promise<ProjectDetail> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/detail',
    { projectUuid: uuid },
    true
  )
  return response.json as ProjectDetail
}

export const fetchProjectDetailByCode = async (
  code: string
): Promise<ProjectDetail> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/detail',
    { projectCode: code },
    true
  )
  return response.json as ProjectDetail
}

export const fetchAssignedProjects = async (): Promise<ProjectDetail[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/assigned'
  )
  return response.json as ProjectDetail[]
}
